<template>
  <nav v-if="links.length > 1">
    <ul class="pagination">
      <li class="page-link" @click="previousPage" :disabled="page === 1">Previous</li>
      <li
        v-for="(pageItem, index) in links" :key="index"
        class="page-link"
        :class="[pageItem.pageNumber === page ? 'active disabled' : '', pageItem.disabled ? 'disabled' : '']"
        @click.stop="toPage(pageItem.pageNumber)">
        {{ pageItem.pageNumber}}
      </li>
      <li class="page-link" @click="nextPage" :disabled="page === pages">Next</li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    pages: {
      type: Number,
      required: true,
      default: 1
    },
    page: {
      type: Number,
      required: true,
      default: 1
    },
    pageSize: {
      type: Number,
      required: true,
      default: 10
    },
    numberOfLinks: {
      type: Number,
      required: false,
      default: 2
    }
  },
  computed: {
    links () {
      let links = []
      for (let i = 1; i <= this.pages; i++) {
        if (i === 1 || i === this.pages || i === this.page || ((i >= this.page - this.numberOfLinks) && (i <= this.page + this.numberOfLinks))) {
          links.push({
            pageNumber: i,
            disabled: false
          })
        } else {
          if ((i === (this.page - (this.numberOfLinks + 1))) || (i === this.page + this.numberOfLinks + 1)) {
            links.push({
              pageNumber: '...',
              disabled: true
            })
          }
        }
      }
      return links
    }
  },
  methods: {
    toPage (page) {
      if (this.page !== page) {
        this.$emit('update:page', page)
        this.$emit('update')
      }
    },
    nextPage () {
      let nextPage = this.page < this.pages ? this.page + 1 : this.pages
      if (this.page !== nextPage) {
        this.$emit('update:page', nextPage)
        this.$emit('update')
      }
    },
    previousPage () {
      let previousPage = this.page > 1 ? this.page - 1 : 1
      this.$emit('update:page', previousPage)
      this.$emit('update')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Pagination.vue